var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{attrs:{"hidden":""}},[_vm._v("Please waiting, logout is in process....")])
}
var staticRenderFns = []

export { render, staticRenderFns }